// src/AudioSpectrum/colorUtils.js

export const getColor = (value, max = 255) => {
  const ratio = value / max;
  if (ratio < 0.5) {
    const r = 0;
    const g = Math.floor(ratio * 2 * 255);
    const b = Math.floor((1 - ratio * 2) * 255);
    return `rgb(${r},${g},${b})`;
  } else {
    const r = Math.floor((ratio - 0.5) * 2 * 255);
    const g = Math.floor((1 - (ratio - 0.5) * 2) * 255);
    const b = 0;
    return `rgb(${r},${g},${b})`;
  }
};

export const getHSLColor = (hue, saturation = 100, lightness = 50) => {
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

export const getRainbowColor = (index, total) => {
  const hue = (index / total) * 360;
  return getHSLColor(hue, 100, 50);
};